import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import * as $ from 'jquery';

@createModule('SearchFlyout')
/**
 * search-flyout module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class SearchFlyout extends TerrificSpec {
	$ctx: JQuery;
	$inputElement: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$inputElement = this.$ctx.find('.js-search-input');
		this.$inputElement.on('click', (event: Event) => {
			event.stopPropagation();
		});
		this.$inputElement.on('keyup', this._handleInputChange.bind(this));
		this.$ctx.find('.js-m-search-flyout__close').on('click', () => {
			$(window).trigger('searchFlyout:close');
		});

		//when the searchFlyout is opened we need to check if there is any content and then show the delete button
		$(window).on('searchFlyout:open', this._open.bind(this));

		$(window).on('searchFlyout:close', this._close.bind(this));

		$('.js-search-delete').on('click', (event: Event) => {
			this._deleteFromInput(event);
			event.stopPropagation();
		});
		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}

	_handleInputChange(event: any) {
		let inputString = this.$inputElement.val() as string;
		let newLinkUrl = this.$ctx.data('baseurl') + inputString;
		let $searchLink = $(this.$ctx).find('.js-m-search-flyout__search-submit');

		if (inputString.length >= 1) {
			$('.js-search-delete').addClass('m-search-flyout__search-delete--active');
		} else {
			$('.js-search-delete').removeClass('m-search-flyout__search-delete--active');
		}

		if (event.keyCode == 13) {
			window.location.href = newLinkUrl;
		}

		$searchLink.attr('href', newLinkUrl);
	}

	_deleteFromInput(event: Event) {
		this.$inputElement.val('');
		this._handleInputChange(event);
		this.$inputElement.focus();
	}

	_open(event: Event) {
		$(window).trigger('enablePreventStickyScrollBehaviour');
		$(window).trigger('lockScrolling');
		this.$inputElement.focus();
		this._handleInputChange(event);
	}

	_close() {
		$(window).trigger('disablePreventStickyScrollBehaviour');
		$(window).trigger('unlockScrolling');
		$('html').removeClass('no-scrolling--without-scrollbar');
		this.$inputElement.val('');
		$('.js-flyout-container').removeClass('m-search-flyout--active');
	}

	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
